import { IRequestOnSubmit } from "../IRequestModel/CreateFormControl/IRequestOnSubmit";
import { IMemoDetailModel } from "../IRequestModel/IMemoDetailModel";

export const Validation = (
  _submitType: string,
  memoDetail: IMemoDetailModel,
  lineApproval: any,
  dateValidField1: any[],
  dateValidField2: any[],
  message: any[]
) => {
  let error_result: any[] = [];

  if (_submitType === "draft" || _submitType === "cancel") {
    if (memoDetail.company_id === 0 && _submitType === "draft") {
      error_result.push("Company");
    }
  } else {
    if (memoDetail.company_id === 0) {
      error_result.push("Company");
    }
    if (!memoDetail.subject) {
      error_result.push("Subject");
    }
    if (lineApproval.length <= 0) {
      error_result.push("Line Approve");
    }
    if (dateValidField1 !== null && dateValidField2 !== null) {
      if (Array.isArray(dateValidField1) && Array.isArray(dateValidField2)) {
        dateValidField1.forEach((record, idx) => {
          if (record > dateValidField2[idx]) {
            error_result.push({
              type: "validfield",
              message: `บรรทัดที่ ${idx + 1} ${message}`,
            });
          }
        });
      } else if (dateValidField1 > dateValidField2) {
        error_result.push({
          type: "validfield",
          message: message,
        });
      }
    }
  }

  return error_result;
};

export const ResponeValidation = (_respone: any) => {
  var _checkRespone: boolean = false;
  try {
    if (_respone.messageType === "success") {
      _checkRespone = true;
    }
    return _checkRespone;
  } catch (error) {
    _checkRespone = false;
    return _checkRespone;
  }
};
